__turbopack_context__.v({
  "fieldset": "DesktopFilters-module-scss-module__UqHWyq__fieldset",
  "form": "DesktopFilters-module-scss-module__UqHWyq__form",
  "hidden": "DesktopFilters-module-scss-module__UqHWyq__hidden",
  "label": "DesktopFilters-module-scss-module__UqHWyq__label",
  "legend": "DesktopFilters-module-scss-module__UqHWyq__legend",
  "radio": "DesktopFilters-module-scss-module__UqHWyq__radio",
  "radio_label": "DesktopFilters-module-scss-module__UqHWyq__radio_label",
  "scroll_to_top_button": "DesktopFilters-module-scss-module__UqHWyq__scroll_to_top_button",
  "sort_by": "DesktopFilters-module-scss-module__UqHWyq__sort_by",
});
